import React from "react";
import { drawPicker } from "../popovers/Picker";
import { getSignal } from "../App";
import Cookies from 'js-cookie';
export default function StoreSelector() {

    const session = window?.login_session || {};
    const stores = session?.available_corps?.filter(item => item.can_bmo).map(item => {
        return {
            value: item.id,
            label: item.name
        }
    }) || [];

    const showStores = () => {
        drawPicker({
            value: "", title: "Change location", closeable: true, mask_close : true, route: window.bm_state.value, callback: (e) => {
                if (e) {
                    window.history.replaceState(null, '', '/' + e.toString());
                    Cookies.set("workstation", null, { expires: 14 })
                    window.location.reload();
                }
            }, offset: [0, 10],
            options: stores
        })
    }

    return (
        <>
            <strong className="text-light" style={{ "fontSize": "14px" }}>
                <a onClick={() => showStores()}>{window?.credentials?.store_name}▾</a>
            </strong>
        </>
    )

}